module.exports = __webpack_public_path__ + "static/img/attachment-pdf.bce4ba74.png";